import { useAuth } from 'layout/context/auth-context'
import { useEffect, useState } from 'react'
import { getBrazilDate } from 'shared/utils/get-brazil-date'
import anprEventApiService from '../../anpr-events/api/anpr-event.api'
import { ANPREventQueryParams } from '../../anpr-events/types/anpr-event-query-param'
import { classifyDirection } from '../../anpr-events/utils/classify-direction'

export interface VehicleFlowCounts {
  entries: number
  exits: number
  /** entries - exits — proxy de "quantos veículos estão dentro agora". */
  balance: number
}

export interface UseVehicleFlowHookReturn {
  flow: VehicleFlowCounts
  loading: boolean
}

const blankFlow: VehicleFlowCounts = { entries: 0, exits: 0, balance: 0 }

export const useVehicleFlow = (): UseVehicleFlowHookReturn => {
  const { clientId } = useAuth()
  const [flow, setFlow] = useState<VehicleFlowCounts>(blankFlow)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!clientId) {
      return
    }

    const params = {
      endDate: getBrazilDate('end'),
      startDate: getBrazilDate('start'),
      clientId,
    } as ANPREventQueryParams

    setLoading(true)

    anprEventApiService
      .getANPREventsDirectionCounts(params)
      .then((response) => {
        const totals = response.responseObject.reduce(
          (acc, { direction, count }) => {
            if (classifyDirection(direction) === 'in') {
              acc.entries += count
            } else {
              acc.exits += count
            }
            return acc
          },
          { entries: 0, exits: 0 }
        )

        setFlow({
          ...totals,
          balance: totals.entries - totals.exits,
        })
      })
      .catch((err) => {
        console.error(
          '⚠️ Dashboard: Falha ao carregar fluxo de entrada/saída:',
          err
        )
        setFlow(blankFlow)
      })
      .finally(() => setLoading(false))
  }, [clientId])

  return { flow, loading }
}
